import React from 'react';
import { HelpCenterLvl_2_1 } from '../../utils/constant';
import HelpCenterTemplate from '../../components/HelpCenterComponents/HelpCenterTemplate';
import {
  LicensingHeadings,
  PartnershipHeadings,
} from '../../components/data/data/HelpCenter/HelpCenterData';

const Licensing = () => {
  return (
    <HelpCenterTemplate
      pageTitle="Licensing"
      sectionTitle="Understanding Spatial Grid & Business Value"
      sectionDescription="Get started"
      articlesData={LicensingHeadings}
      basePath="/help-center/licensing-articles"
      breadcrumbPath={{
        name: 'Licensing',
        path: '/help-center/licensing',
      }}
      searchPlaceholder="Search the Spatial Grid Help Center"
      showArticleCount={true}
      maxDisplayArticles={7}
      seeAllLink="/help-center/licensing-articles"
    />
  );
};

export default Licensing;
